import {
  GET_PATIENT_COMPLAINTS,
  GET_PATIENT_COMPLAINTS_SUCCESS,
  GET_PATIENT_COMPLAINTS_FAIL,
} from "./actionTypes";
import {
  getPatientComplaintsFail,
  getPatientComplaintsSuccess,
  getPatientComplaintsRequest,
} from "./actions";

import { takeEvery, put, call } from "redux-saga/effects";
import axios from "axios";

import toast from "react-hot-toast";
import { url } from "APIs/URLS";

export const getPatientComplaintsAPI = async () => {
  try {
    console.log("token in saga");
    const response = await axios.get(
      `${url}/Feedbacks/allcomplaints`

      // {
      //   headers: {
      //     "content-type": "application/json",
      //     Authorization: `Bearer  ${token}`,
      //   },
      // }
    );
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* getPatientComplaintsList() {
  try {
    // const patientappointments = yield getPatientAppointmentsAPI(token);
    const response = yield call(getPatientComplaintsAPI);
    console.log("patientcomplaints", response);
    yield put(getPatientComplaintsSuccess(response));
  } catch (error) {
    yield put(getPatientComplaintsFail(error));
  }
}
function* PatientComplaintSaga() {
  yield takeEvery(GET_PATIENT_COMPLAINTS, getPatientComplaintsList);
}

export default PatientComplaintSaga;
